import css from 'styled-jsx/css';

const styles = css.global`/* #duvidas-frequentes-banner {
    background: #FBFBFB;
  } */
  
  #duvidas-frequentes-banner.stacked-banner {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: start;
    position: relative;
  }
  
  #duvidas-frequentes-banner .bg-image-wrapper {
    height: calc(100vh - 300px);
    max-height: 454px;
    min-height: 270px;
  }
  
  #duvidas-frequentes-banner .bg-image-wrapper picture {
    display: flex;
    width: 100%;
    height: 100%;
  }
  
  #duvidas-frequentes-banner .bg-image-wrapper picture img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
  }
  #duvidas-frequentes-banner .fade-banner {
    opacity: 0.25;
    background: var(--Red-Red-Boston-01, #C00);
    position: absolute;
    width: 100%;
    height: calc(100vh - 300px);
    max-height: 454px;
    min-height: 270px;
  }
  #duvidas-frequentes-banner .fade-banner-gradiente {
    background: linear-gradient(90deg, #900 0%, rgba(153, 0, 0, 0.73) 10.94%, rgba(153, 0, 0, 0.00) 56.77%);
    width: 100%;
    height: calc(100vh - 300px);
    max-height: 454px;
    min-height: 270px;
    position: absolute;
  }
  
  #duvidas-frequentes-banner .santander-symbol {
    background-image: url(assets/c2c/banners/santander-symbol.svg);
    width: 100%;
    height: 280px;
    position: absolute;
    left: -90px;
    background-repeat: no-repeat;
    background-size: contain;
  }
  
  #duvidas-frequentes-banner .text-box-position {
    margin-top: -200px;
    position: relative;
  }
  
  #duvidas-frequentes-banner .text-box {
    background: #990000;
    width: 100%;
    max-width: 849px;
    padding: 24px 16px 40px 16px;
    border-radius: 4px;
    box-sizing: border-box;
    height: 360px;
  }
  
  #duvidas-frequentes-banner .text-box .main-text {
    font-family: 'SantanderHeadline';
    font-size: 32px;
    font-weight: 400;
    line-height: 48px;
    text-align: left;
    margin-bottom: 8px;
    margin-bottom: 8px;
    color: #fff;
  }
  
  #duvidas-frequentes-banner .text-box .alt-text {
    font-family: 'SantanderText';
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    text-align: left;
    margin-bottom: 24px;
    color: #fff;
    max-width: 630px;
  }
  
  #duvidas-frequentes-banner .text-box .btn-simulate {
    box-sizing: border-box;
    height: 48px;
    width: 200px;
  }
  
  
  @media (min-width: 992px) {
    #duvidas-frequentes-banner .text-box {
      padding: 24px 47px;
      height: 245px;
    }
  
    #duvidas-frequentes-banner .santander-symbol { 
      left: 0;
      width: 537px;
      height: 500px;
    }
  
    #duvidas-frequentes-banner .bg-image-wrapper,
    #duvidas-frequentes-banner .fade-banner,
    #duvidas-frequentes-banner .fade-banner-gradiente {
      height: calc(100vh - 180px);
      max-height: 436px;
      min-height: 300px;
    }
  }
  /* @media (min-width: 1200px) {
    #duvidas-frequentes-banner .bg-image-wrapper picture img {
      object-position: 0 40%;
    } 
  }
  
  @media (min-width: 1600px) {
    #duvidas-frequentes-banner .bg-image-wrapper picture img {
      object-position: 0 40%;
    } 
  }
  
  @media (min-width: 1900px) {
    #duvidas-frequentes-banner .bg-image-wrapper picture img {
      object-position: 0 39%;
    } 
  } */`;

export default styles;